<template>
  <div>
    <el-form
      ref="form"
      size="mini"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
    >
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item
            :label="$l('INDEX.fabric_label_fabricPositionName') || '面料位置'"
            prop="fabricPositionCode"
          >
            <dict-select
              v-model="formData.fabricPositionCode"
              :selectedLabel.sync="formData.fabricPositionName"
              url="/master/common/dict/biz"
              :body="fabricPositionParams"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              style="width: 100%"
              size="mini"
              filterable
              clearable
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="18">
          <el-form-item
            :label="$l('INDEX.form_label_fabricNo') || '面料编号'"
            prop="fabricNo"
          >
            <el-input v-model="formData.fabricNo" readonly :size="'mini'">
              <el-button
                :disabled="disabled"
                slot="append"
                icon="el-icon-finished"
                @click="() => (fabricDialogVisible = true)"
              ></el-button>

              ></el-input
            >
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item
            :label="$l('INDEX.form_label_fabricDisplayName') || '面料显示名称'"
          >
            <el-input
              v-model="formData.fabricDisplayName"
              readonly
              size="mini"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item :label="$l('form_label_fabricWidth') || '面料门幅'">
            <el-input-number
              v-model="formData.fabricWidth"
              size="mini"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
              :min="0"
              :step="1"
              :precision="2"
              controls-position="right"
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('INDEX.form_label_fabric_width_unit') || '门幅单位'"
          >
            <dict-select
              v-model="formData.widUnit"
              url="/master/common/dict/biz"
              :body="fabricWidthUnitParams"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              style="width: 100%"
              size="mini"
              filterable
              clearable
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('INDEX.form_label_fabricWeight') || '面料克重'"
          >
            <el-input-number
              v-model="formData.fabricWeight"
              size="mini"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
              :min="0"
              :step="1"
              :precision="2"
              controls-position="right"
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('INDEX.form_label_fabricWeightUnit') || '克重单位'"
          >
            <dict-select
              v-model="formData.fabricWeightUnit"
              url="/master/common/dict/biz"
              :body="fabricWeightUnitParams"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              style="width: 100%"
              size="mini"
              filterable
              clearable
            ></dict-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item :label="$l('form_label_moq') || '起定量'" prop="moq">
            <el-input-number
              v-model="formData.moq"
              size="mini"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入'"
              :min="0"
              :step="1"
              :precision="0"
              controls-position="right"
              style="width: 100%"
            >
            </el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_moq_unit') || '起定量单位'"
            prop="moqUnit"
          >
            <dict-select
              v-model="formData.moqUnit"
              url="/master/common/dict/biz"
              :body="moqUnitParams"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              style="width: 100%"
              size="mini"
              filterable
              clearable
            ></dict-select>
          </el-form-item>
        </el-col>

        <!-- <el-col :span="12">
          <el-form-item :label="$l('INDEX.form_label_scm') || '工厂名称'">
            <dict-select
              v-model="formData.scmCode"
              url="/master/common/dict/scmPartners"
              :placeholder="$l('INDEX.tips_select_placeholder') || '请选择'"
              clearable
              filterable
              size="mini"
              style="width:100%"
            ></dict-select>
          </el-form-item>
        </el-col> -->
      </el-row>
    </el-form>

    <choose-fabric-dialog
      :title="$l('INDEX.dialog_title_fabric_information') || '添加面料信息'"
      :visible.sync="fabricDialogVisible"
      type="radio"
      @confirm="onFabricConfirm"
    />
  </div>
</template>
<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  props: {
    disabled: Boolean,
    amzMoqCode: String,
    amzMaterialCode: String,
    params: {type: Object, default: () => {}},
  },
  data() {
    return {
      formData: {},
      fabricDialogVisible: false,
      fabricPositionParams: {dictType: 'fabricPosition'},
      moqUnitParams: {dictType: 'moqUnit'},
      fabricWidthUnitParams: {dictType: 'widUnit'},
      fabricWeightUnitParams: {dictType: 'fabricWeightUnit'},

      rules: {
        fabricPositionCode: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择',
            trigger: 'change',
          },
        ],
        fabricNo: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择',
            trigger: 'change',
          },
        ],
        moqUnit: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择',
            trigger: 'change',
          },
        ],
        moq: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.amzMaterialCode) return

      this.$api
        .ecomAmzMoqMaterialDetailApi({
          amzMaterialCode: this.amzMaterialCode,
        })
        .then((res) => {
          this.formData = res.body
        })
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) {
        return
      }
      this.loadingOpen()
      this.$api
        .ecomAmzMoqMaterialSaveApi({
          amzMoqCode: this.amzMoqCode,
          ...this.formData,
        })
        .then((res) => {
          this.loadingClose()
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_save_ok') || res.msg,
            type: 'success',
          })
          this.$emit('close')
          this.$emit('reload')
        })
        .catch(() => {
          this.loadingClose()
        })
    },
    onFabricConfirm(data) {
      if (!data) return
      this.formData.fabricCode = data.fabricCode
      this.formData.fabricNo = data.fabricNo
      this.formData.fabricDisplayName =
        data.fabricName + ' ' + data.fabricContent
      this.formData.fabricWeight = data.fabricWeight
      this.formData.fabricWeightUnit = data.fabricWeightUnit
      this.formData.fabricWidth = data.wid
      this.formData.widUnit = data.widUnit
      this.formData.scmCode = data.supCode
    },

    cancel() {
      if (this.disabled) {
        this.close()
        return
      }
      this.openQuestion()
    },
    close() {
      this.$emit('close')
    },
    openQuestion() {
      this.$confirm(
        this.$l('INDEX.tips_question_save') || '是否要保存更改',
        this.$l('INDEX.tips_question_title') || '提示信息',
        {
          distinguishCancelAndClose: true,
          confirmButtonText: this.$l('INDEX.btn_save') || '保存',
          cancelButtonText: this.$l('INDEX.btn_no_save') || '不保存',
        }
      )
        .then(() => {
          this.save()
        })
        .catch((action) => {
          if (action === 'cancel') {
            this.close()
          }
        })
    },
  },
}
</script>
